const formatter = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

/**
 * Converts an ISO 8601 UTC timestamp to local browser time.
 * @param date - ISO 8601 string or Date object
 * @returns Formatted date string in `YYYY-MM-DD HH:mm` (e.g. `2026-05-19 23:27`)
 */
export const formatDateTimeLocal = (date: string | Date): string =>
  formatter.format(new Date(date)).replace(', ', ' ');
